import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {NgIf} from "@angular/common";

@Component({
  standalone: true,
  selector: 'app-language-header',
  templateUrl: './language-header.component.html',
  imports: [
    NgIf
  ],
  styleUrl: './language-header.component.scss'
})
export class LanguageHeaderComponent implements OnInit {

  isLanguageOpen: boolean = false;

  constructor(private translate: TranslateService) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.translate.onLangChange.subscribe(event => {
      // console.log("Language changed to: ", event.lang);
    });
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    this.isLanguageOpen = false
  }

  toggleLanguage() {
    this.isLanguageOpen = !this.isLanguageOpen;
  }

}
